import { render, staticRenderFns } from "./databaseSettingsModal.vue?vue&type=template&id=ea452fee&scoped=true"
import script from "./databaseSettingsModal.vue?vue&type=script&lang=js"
export * from "./databaseSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./databaseSettingsModal.vue?vue&type=style&index=0&id=ea452fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea452fee",
  null
  
)

export default component.exports